export default __webpack_public_path__ + "static/media/442.48c1a995.svg";